export default __webpack_public_path__ + "static/media/digital-agency.f0cb2c58.png";